import cx from 'classnames'
import { Component } from 'react'
import { connect } from 'react-redux'
import renderHTML from 'react-render-html'
import { Link } from 'react-router-dom'

import { withLegacyRouter } from '../../../decorators'
import Document from '../../shared/DocumentViewer/document'
import {
  Card,
  CircularProgress,
  Button,
  Modal
} from '../../shared/NarusMaterial'
import { setClientName } from '../actions'

import { getReport, getHtml } from './actions'
import BackIcon from './components/BackIcon'
import ShareFAB from './components/FAB'
import styles from './index.module.css'

class ReportRoot extends Component {
  constructor (props) {
    super(props)
    if (!props.clientName) {
      props.dispatch(setClientName(props.params.clientName))
    }
    this.state = {
      openHtml: false
    }
    this.closeHtmlModal = this.closeHtmlModal.bind(this)
    this.openHtmlModal = this.openHtmlModal.bind(this)
  }

  componentDidMount () {
    const { dispatch, params } = this.props
    const { id: patientId, reportType, reportId } = params
    dispatch(getReport(patientId, reportType, reportId, 'pdf'))
  }

  openHtmlModal () {
    const {
      params: { id, reportType, reportId },
      dispatch
    } = this.props
    dispatch(getHtml(id, reportType, reportId, 'html'))
    this.setState({
      openHtml: true
    })
  }

  closeHtmlModal () {
    this.setState({
      openHtml: false
    })
  }

  renderHtmlModal () {
    const { openHtml } = this.state
    const { reports } = this.props
    const actions = [
      <Button
        key={1}
        onClick={this.closeHtmlModal}
        label='Close'
      />
    ]
    const htmlString = String(reports.reportHtml)
    const html = renderHTML(htmlString)
    if (openHtml && !reports.loadingHtml) {
      return (
        <Modal
          title='Report Html'
          actions={actions}
        >
          {html}
        </Modal>
      )
    }
    return null
  }

  renderBody () {
    const { params, reports } = this.props
    if (reports.loading) {
      return <CircularProgress />
    }
    return (
      <Document
        mime='application/pdf'
        hasStickyPB={!!params.id}
        data={reports.reportData}
      />
    )
  }

  render () {
    const { params } = this.props
    const { id: patientId, clientName, reportType, reportId } = params
    const body = this.renderBody()

    return (
      <div className='wrapper report-root'>
        <div
          className='breadcrumbs-row'
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '12px',
            paddingBottom: '12px'
          }}
        >
          <Link
            to={`/patient/${clientName}/${patientId}/patientFolder`}
            title='Go back to Patient Folder'
            textStyle='bold'
            className={cx(styles.backButton)}
          >
            <BackIcon />
            <span>
              Back
            </span>
          </Link>
          <ShareFAB
            reportMeta={{
              patientId,
              reportType,
              reportId
            }}
          />
        </div>

        <Card height='auto'>{body}</Card>

        {this.renderHtmlModal()}
        <Button
          style={{
            position: 'absolute',
            top: '-1000px'
          }}
          onClick={this.openHtmlModal}
          label='Open Html'
        />
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  reports: redux.reports,
  clientName: redux.patient.clientName
})

export default connect(mapStateToProps)(withLegacyRouter(ReportRoot))
